module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('div', {
    staticClass: "not-found-wrap"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('p', [_vm._v("抱歉！页面无法访问……点击下方按钮返回首页")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "./"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/ibroadcast/back2home3.png"),
      "width": "390"
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e172857c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/notfound.vue
// module id = 857
// module chunks = 2